import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import PostTitle from '../components/Title/PostTitle';
import { SectionLayout } from '../components/Layouts';
import * as T from '../components/Typography';
import { Row, Col } from '../components/Grid';
import Image from '../components/PreviewCompatibleImage';
import SocialShare from '../components/SocialShare';

import ActionCardsSection from '../sections/ActionCards';
import { GeneralCardsSection } from '../sections/Cards';
import { LearningSection } from '../sections/CardsSections';
import composeStyle from '../utils/composeStyle';

import placeholderData from '../utils/placeholderData';

import Button from '../components/Button';
import * as S from './style';

const Subtitle = composeStyle(T.H4SemiBold, 'H4SemiBold', 'P16Bold');

export const LearnTemplate = ({
  content = 'content...',
  title = 'title...',
  subtitle = 'subtitle...',
  category = 'learn',
  imageInfo = { image: 'cardPlaceholder' },
  reportFile,
  preview,
  impactAndUpdatePostsTitle = 'Impact And Update Posts Title...',
  id,
}) => {
  return (
    <>
      <SectionLayout>
        <Row>
          <Col mb="1.5rem" w={[4, 6, 8]}>
            <PostTitle category={category}>{title}</PostTitle>
          </Col>
        </Row>

        <S.PostDesktopWrapper>
          <Row jc="space-between">
            <Col w={[4, 6, 7]}>
              <S.Content>
                <Subtitle color="gray1" style={{ paddingBottom: 30 }}>
                  {subtitle}
                </Subtitle>
                {content && (
                  <S.PostsContentContainer
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />
                )}
              </S.Content>
            </Col>
            <Col w={[4, 6, 4]}>
              <S.ImgContainer>
                <Image imageInfo={imageInfo} style={{ maxHeight: '250px' }} />
              </S.ImgContainer>
              {reportFile && reportFile.publicURL && (
                <Button
                  color="blue"
                  external
                  to={reportFile.publicURL}
                  style={{ marginTop: '3rem' }}
                >
                  <T.Button16 color="white">Download report</T.Button16>
                </Button>
              )}
            </Col>
          </Row>
        </S.PostDesktopWrapper>

        <S.PostTabletAndMobileWrapper>
          <Row>
            <Col w={[4, 3, 8]}>
              <Subtitle color="gray1" style={{ paddingBottom: 30 }}>
                {subtitle}
              </Subtitle>
            </Col>
            <Col w={[4, 3, 8]}>
              <S.ImgContainer>
                <Image imageInfo={imageInfo} />
              </S.ImgContainer>
            </Col>
            <Col w={[4, 6, 8]} style={{ marginTop: '3rem' }}>
              {content && (
                <S.PostsContentContainer
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              )}
            </Col>
            {reportFile && reportFile.publicURL && (
              <Col w={[4, 3, 8]}>
                <Button
                  color="blue"
                  external
                  to={reportFile.publicURL}
                  style={{ marginTop: '3rem' }}
                >
                  <T.Button16 color="white">Download report</T.Button16>
                </Button>
              </Col>
            )}
          </Row>
        </S.PostTabletAndMobileWrapper>
        {/* social share */}
        <Row>
          <Col mt={5} w={[4, 2, 3]}>
            <SocialShare jc="flex-start" jcT="flex-start" jcM="center" />
          </Col>
        </Row>
      </SectionLayout>
      {preview ? (
        <GeneralCardsSection
          data={placeholderData}
          type="impacts"
          title={impactAndUpdatePostsTitle || 'Learning Section'}
        />
      ) : (
        <LearningSection
          title={impactAndUpdatePostsTitle || 'Impact & updates'}
          type="impacts"
          currentId={id}
          bgcolor="gray2"
        />
      )}
      <ActionCardsSection />
    </>
  );
};

const LearnPage = ({ data }) => {
  const {
    markdownRemark: {
      id,
      html: content,
      frontmatter: {
        title,
        subtitle,
        asideText,
        category,
        postImage,
        reportFile,
        impactAndUpdatePostsTitle,
      } = {},
    } = {},
  } = data;
  return (
    <Layout isPost>
      <LearnTemplate
        content={content}
        title={title}
        subtitle={subtitle}
        asideText={asideText}
        category={category}
        imageInfo={postImage}
        reportFile={reportFile}
        impactAndUpdatePostsTitle={impactAndUpdatePostsTitle}
        id={id}
      />
    </Layout>
  );
};

export const LearnPost = graphql`
  query learnPostQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        subtitle
        category
        impactAndUpdatePostsTitle
        reportFile {
          publicURL
        }
        postImage {
          childImageSharp {
            fluid(quality: 100, maxWidth: 360) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`;

export default LearnPage;
